export default "__VITE_ASSET__DfXVMsKu__"